import { render, staticRenderFns } from "./notice-add-edit.vue?vue&type=template&id=30f9df66&scoped=true&"
import script from "./notice-add-edit.vue?vue&type=script&lang=js&"
export * from "./notice-add-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f9df66",
  null
  
)

export default component.exports